import BaseModel from './BaseModel'

/**
 * @todo Add types for API methods.
 */
export default class AuditLog extends BaseModel {

  static entity = 'audit_log'
  static primaryKey = 'ID'

  declare targetType: string
  declare action: string
  declare actionDetails: object|null
  declare succeeded: boolean
  declare userID: number
  declare username: string
  declare timestamp: string
  declare organizationID: number

  static fields() {
    return {
      targetType: this.string(''),
      action: this.string(''),
      actionDetails: this.attr(null),
      succeeded: this.boolean(null),
      userID: this.number(null),
      username: this.string(''),
      timestamp: this.string(''),
      organizationID: this.number(null),
    }
  }

  static fetch({
    targetTypes,
    targetIds,
    actions,
    organizationId,
    locationId,
    sortBy,
    desc,
    limit,
    offset,
  }: FetchAuditLogsRequest): Promise<FetchAuditLogsResponse> {

    return this.api()
      .get('/audit-logs', {
        save: false,
        params: {
          targetTypes: targetTypes.join(','),
          targetIDs: targetIds ? targetIds.join(',') : undefined,
          actions: actions ? actions.join(',') : undefined,
          organizationID: organizationId, // note difference in case
          locationID: locationId, // note difference in case
          sortBy: sortBy,
          desc: desc === undefined ? undefined : (desc ? '1' : '0'),
          limit: limit,
          offset: offset,
        },
      }).then(response => {
        return response.response.data
      })

  }

  static write({
    targetType,
    targetID = null,
    action,
    otherAction = null,
    actionDetails = null,
    locationID = null,
    organizationID = null,
  }: WriteAuditLogsRequest): Promise<void> {

    const request: WriteAuditLogsRequest = {
      targetType,
      targetID,
      action,
      otherAction,
      actionDetails,
      locationID,
      organizationID,
    }

    return this.api()
      .post('/audit-logs', request, {save: false})
      .then(_ => {})

  }

}

export interface FetchAuditLogsRequest {
  targetTypes: string[]
  targetIds?: number[]
  actions?: string[]
  organizationId?: number
  locationId?: number
  sortBy?: string
  desc?: boolean
  limit?: number
  offset?: number
}

export interface FetchAuditLogsResponse {
  records: FetchAuditLogsResponseRecord[]
  total: number
}

export interface FetchAuditLogsResponseRecord {
  ID: number
  targetType: string
  targetID: null | number
  action: string
  actionDetails: null | any
  userID: null | number
  username: null | string
  timestamp: string // TODO: Temporal.PlainDateTime
  organizationID: null | number
  succeeded: boolean
}

export interface WriteAuditLogsRequest {
  targetType: string
  targetID: null | number
  action: string
  otherAction: null | string
  actionDetails: null | object
  locationID: null | number
  organizationID: null | number
}
